import React, { useState } from "react";

import { Form, Formik } from "formik";
import * as yup from "yup";

import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";

import { auth } from "@jumbo/services/auth/firebase/firebase";
import { useAuthSignInWithEmailAndPassword } from "@react-query-firebase/auth";

import { useHistory } from "react-router-dom";
import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";

import { useOnLoginRegistro } from "../hook/index";

import { consultarGrupoGenerico } from "app/modules/app-configuracion/services/configuracionServices";
import { obtenerRegistroCliente } from "../services";
import HouseIcon from "@mui/icons-material/House";
import RefreshIcon from "@mui/icons-material/Refresh";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import { useOnLogout } from "app/modules/app-auth/hook";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ORIGIN_CONNECT } from "app/config/globals";
import {
  obtenerPreevaluacion,
  preevaluacionClienteCredito,
} from "app/modules/app-credito/services/creditoServices";

const validationSchema = yup.object({
  password: yup.string("Ingrese Cédula").required("Cédula es Obligatorio"),
});

const ValidarCedula = () => {
  const { t } = useTranslation();

  const [origen, setOrigen] = useState(localStorage.getItem("origen"));

  const history = useHistory();
  const { setActiveLayout } = useJumboApp();

  const [send, setSend] = useState(false);
  useOnLoginRegistro(send, setSend);
  const { authUser } = useSelector(({ auth }) => auth);

  const [color, setColor] = useState("");
  const [url, setUrl] = useState("");
  const [esperaLogin, setesperaLogin] = useState(true);
  const [loggedUser, setLoggedUser] = useState(false);
  const [mostarRefresh, setMostrarRefresh] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [sendLogout, setSendLogout] = useState(false);
  const [userCode, setUserCode] = useState(false);
  useOnLogout(userCode, sendLogout, setSendLogout);

  //Variables de preevaluacion
  const [identificacionWp, setIdentificacionWp] = useState(
    localStorage.getItem("fwp"),
  );
  const [open, setOpen] = useState(false);
  const [mensajeCliente, setMensajeCiente] = useState("");
  const [continuaProceso, setContinuaProceso] = useState(false);
  const [flujoFinal, setFlujoFinal] = useState("");
  const [datosPreevaluacion, setDatosPreevaluacion] = useState({});
  const [mostrarAprobado, setMostrarAprobado] = useState(false);
  const [mostrarNegado, setMostrarNegado] = useState(false);

  React.useEffect(() => {
    localStorage.setItem("tipocliente", "NUEVO");
    setActiveLayout(LAYOUT_NAMES.SOLO_PAGE);

    // Definimos los identificadores de los timers para controlar solo una llamada
    let timerSend, timerGrupo, timerFlujo, timerRefresh;

    timerSend = setTimeout(() => {
      setSend(true);
    }, 100);

    timerGrupo = setTimeout(() => {
      obtenerGrupo();
    }, 3000);

    timerFlujo = setTimeout(() => {
      validarFlujoWhatsapp();
    }, 4000);

    timerRefresh = setTimeout(() => {
      setMostrarRefresh(true);
    }, 8000);

    // Lógica de colores (esto está bien)
    const config = {
      tvtas: {
        color: "#FF9201",
        url: "https://www.tventas.com/content/55-creditventas",
      },
      corpfav: { color: "#e1251b", url: "https://www.creditofavorito.com/" },
    };
    const selected = config[origen] || config.corpfav;
    setColor(selected.color);
    setUrl(selected.url);

    // Limpiamos el componente
    return () => {
      setSend(false);
      clearTimeout(timerSend);
      clearTimeout(timerGrupo);
      clearTimeout(timerFlujo);
      clearTimeout(timerRefresh);
    };
  }, [refresh]);

  const obtenerGrupo = async () => {
    const resp = await consultarGrupoGenerico(origen, 1);
    if (resp.state) {
      localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
    }
  };
  const validarFlujoWhatsapp = async () => {
    const idGrupo = localStorage.getItem("idGrupoStorage");
    if (identificacionWp !== "null") {
      setIdentificacionWp(localStorage.getItem("fwp"));

      //Obtener registro de preevaluacion
      try {
        const srvObtenerPreev = await obtenerPreevaluacion(
          identificacionWp,
          idGrupo,
        );
        if (srvObtenerPreev.state) {
          const data = srvObtenerPreev.data;
          const datosPreev = {
            identificacion: identificacionWp,
            usuario: data.usuarioCreacion,
            local: data.idLocal,
            origen: "Whatsapp",
            dactilar: data.dactilar,
            celular: data.celular,
            email: data.email,
            estacion: "FlujoWhatsapp",
          };

          try {
            const resp = await preevaluacionClienteCredito(datosPreev);
            console.log(resp);
            if (resp.state) {
              // console.log(resp);
              const flujoRespuesta = resp.data.datosPreevaluacion.flujoFinal;
              setFlujoFinal(resp.data.datosPreevaluacion.flujoFinal);
              //setMontoSugerido(resp.data.datosMontoSugerido.valor)
              setDatosPreevaluacion(resp.data);
              let monto, montoAbastos;
              switch (flujoRespuesta) {
                case "NEGADO":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarNegado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
                case "REVISION":
                  monto =
                    resp.data.datosMontoSugerido.valor > 2500
                      ? 2500
                      : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor;

                  setMensajeCiente(
                    "Preevaluacion exitosa, continua con la solicitud.",
                  );
                  setMostrarAprobado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "EXPRESS":
                  monto =
                    resp.data.datosMontoSugerido.valor > 2500
                      ? 2500
                      : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor.toFixed(0);

                  montoAbastos = resp.data.datosMontoSugerido.valorAbastos;
                  const textAbastos =
                    resp.data.datosPreevaluacion.idGrupo === 1
                      ? ` y para Abastos de $${montoAbastos.toFixed(0)}`
                      : ``;
                  setMensajeCiente(
                    `Felicidades tienes un monto preaprobado para Mercancias Generales de $${monto}${textAbastos} y puedes usarlos hoy mismo.`,
                  );
                  setMostrarAprobado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "DEVUELTA":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarAprobado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "SolicitudActiva":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarNegado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
                default:
                  setMensajeCiente(
                    "En estos momentos no podemos realizar su Preevaluación por favor intente en unos minutos.",
                  );
                  setMostrarNegado(true);
                  // setLoadingPreevaluar(false);
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
              }

              // if (resp.data.validacion) {
              //   //console.log(resp.data.mensaje);
              //   setMensajeCiente(resp.data.mensaje);
              //   setMostrarAprobado(true);
              //   setLoadingPreevaluar(false);
              // } else {
              //   setMensajeCiente(resp.data.mensaje);
              //   setMostrarNegado(true);
              //   setLoadingPreevaluar(false);
              // }
            } else {
              console.log(resp.message);
              setMensajeCiente(resp.message);
              // setLoadingPreevaluar(false);
              setContinuaProceso(false);
              setOpen(true);
            }
          } catch (err) {
            console.log(err.message);
          }
        } else {
          console.log(srvObtenerPreev.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
    setLoggedUser(true);
  };

  const handleCloseEspera = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      //console.log(reason);
      setesperaLogin(true);
    } else {
      setesperaLogin(false);
    }
  };

  const mutation = useAuthSignInWithEmailAndPassword(auth, {
    onError(error) {
      console.log(error);
    },
    onSuccess(data) {
      history.push("/");
    },
  });

  const onSignIn = async (password, setSubmitting) => {
    setSubmitting(true);
    try {
      localStorage.setItem("cedula", password);
      let response = await obtenerRegistroCliente(
        password,
        localStorage.getItem("idGrupoStorage"),
      );
      //debugger;
      if (response.state) {
        alert("Ya te encuentras registrado, por favor inicia sesión.");
        history.push("/signincli");
        //debugger;
      } else {
        //si no registrado envía welcome1
        history.push("/auth-pages/welcome");
      }
      // } else {
      //   //alert(response.message);
      //   dispatch(fetchError(response.message));
      // }
    } catch (e) {
      history.push("/auth-pages/welcome");
    } finally {
      setSubmitting(false);
    }
  };

  const handleRefresh = async () => {
    setSend(false);
    setMostrarRefresh(false);
    setRefresh(!refresh);
  };

  const handleRedirect = () => {
    /*     setSend(false);
    setMostrarRefresh(false);
    setesperaLogin(false);
    setLoggedUser(false);
    localStorage.removeItem("tipocliente");
    localStorage.removeItem("idGrupoStorage");
    localStorage.removeItem("cedula");
    localStorage.removeItem("origen"); */

    const urlAutoservice = process.env.REACT_APP_URL_AUTOSERVICE;

    if (localStorage.getItem("station") === "autosrv") {
      setSendLogout(true);
      window.opener = null;
      window.open(urlAutoservice, "_self");
      window.close();
    } else {
      window.open(url, "_self");
    }
  };

  const handleClose = () => {
    // setOpen(false);
  };
  const routeChange = (cambioCupo) => {
    const path = "/credito/flujop";
    history.push(path, {
      data: {
        identificacion: identificacionWp,
        flujoFinal: flujoFinal,
        cambioCupo: cambioCupo,
        datosPreevaluacion: datosPreevaluacion,
      },
    });
  };

  return (
    <>
      {!loggedUser ? (
        <Dialog
          onClose={handleCloseEspera}
          aria-labelledby="customized-dialog-title"
          open={esperaLogin}
          fullWidth
        >
          <DialogContent dividers>
            {!mostarRefresh ? (
              <Stack direction={"column"} spacing={5}>
                <Box marginTop={5}>
                  <LinearProgress color="inherit" />
                </Box>
                <Box margin={5}>
                  <Typography align="center">
                    Un momento estamos preparando todo.
                  </Typography>
                </Box>
                <Box margin={5}></Box>
              </Stack>
            ) : (
              <>
                <Box margin={5}>
                  <Stack
                    direction={"column"}
                    spacing={5}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <RefreshIcon fontSize="large" />
                    <Button
                      size="lg"
                      variant="outlined"
                      //startIcon={<RefreshIcon />}
                      onClick={handleRefresh}
                    >
                      <Typography>
                        Hubo un inconveniente, intenta de nuevo.
                      </Typography>
                    </Button>
                  </Stack>
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      ) : (
        <Div
          sx={{
            flex: 1,
            flexWrap: "wrap",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: (theme) => theme.spacing(2),
          }}
        >
          <Box
            component="img"
            src={`${process.env.REACT_APP_IMAGES_PATH}/logo-${origen}.png`}
            sx={{
              justifyContent: "center",
              width: 350,
              height: 140,
              "@media (max-width: 1500px)": { width: 300, height: "110px" },
            }}
          />
          <Card sx={{ maxWidth: "100%", width: 360, mb: 4 }}>
            <Div
              sx={{
                position: "relative",
                height: "170px",
                "@media (max-width: 1500px)": { height: "140px" },
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  backgroundColor: color,
                  height: "170px",
                  "@media (max-width: 1500px)": { height: "140px" },
                }}
              />
              <Div
                sx={{
                  flex: 1,
                  inset: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  p: (theme) => theme.spacing(3),
                }}
              >
                <Stack direction={"column"}>
                  <Typography
                    variant={"h2"}
                    sx={{
                      color: "common.white",
                      fontSize: "1.5rem",
                      mb: 0,
                    }}
                  >
                    ¡Bienvenido!
                  </Typography>
                  <Typography
                    variant={"h4"}
                    sx={{
                      color: "common.white",
                      fontSize: "1.5 rem",
                      mb: 0,
                    }}
                  >
                    {/*  Registrate para aplicar a tu Crédito Directo. */}
                    {`Registrate para aplicar a tu ${t(
                      `${ORIGIN_CONNECT[origen]}.title` ||
                        "mensajesCreditoFav.title",
                    )}`}
                  </Typography>
                </Stack>
              </Div>
            </Div>
            <CardContent sx={{ pt: 0 }}>
              <Formik
                validateOnChange={true}
                initialValues={{
                  password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(data, { setSubmitting }) => {
                  /* setSubmitting(true); */
                  onSignIn(data.password, setSubmitting);
                  /* setSubmitting(false); */
                }}
              >
                {({ isSubmitting }) => (
                  <Form
                    style={{ textAlign: "left" }}
                    noValidate
                    autoComplete="off"
                  >
                    <Typography
                      sx={{ textWrap: "balance" }}
                      textAlign={"left"}
                      variant={"h3"}
                      mb={1}
                    >
                      {`Ingresa tus datos como consta en tu cédula de identidad para agilizar el proceso de tu ${t(
                        `${ORIGIN_CONNECT[origen]}.title` ||
                          "mensajesCreditoFav.title",
                      )}`}
                      <br />
                      <br />
                    </Typography>

                    {mutation.isError && <p>{mutation.error.message}</p>}
                    <Div sx={{ mb: 2, mt: 1 }}>
                      <JumboTextField
                        fullWidth
                        name="password"
                        label="Ingresa tu Cédula"
                      />
                    </Div>

                    <section style={{ margin: "15px 0" }}>
                      <SCSLoadingButton
                        loading={isSubmitting}
                        size={100}
                        type="submit"
                        titulo="CONTINUAR"
                      />
                    </section>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>

          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            <DialogContent
              sx={{
                backgroundColor: "#e9f0ffff",
                borderRadius: 4,
                p: 3,
              }}
            >
              <Card
                elevation={0}
                sx={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="wrap"
                  >
                    <Box flex="1" minWidth="220px">
                      <Typography
                        variant="h2"
                        fontWeight="bold"
                        color="text.primary"
                        // gutterBottom
                      >
                        Hola, aqui puedes continuar tu solicitud de crédito. CI:{" "}
                        {identificacionWp}
                      </Typography>
                      <Typography
                        variant="h2"
                        fontWeight="bold"
                        color="text.primary"
                        // gutterBottom
                      >
                        {continuaProceso
                          ? "PREEVALUACION EXITOSA"
                          : "PREEVALUACION NO EXITOSA"}
                      </Typography>
                      <Typography
                        variant="h3"
                        color="text.secondary"
                        mb={2}
                        mt={5}
                      >
                        {mensajeCliente}
                      </Typography>
                      {continuaProceso && (
                        <Stack direction={"row"} spacing={2} mt={8}>
                          <Button
                            variant="contained"
                            onClick={() => {
                              routeChange(false);
                            }}
                            sx={{
                              backgroundColor: "#FFFFFF",
                              color: "#000",
                              textTransform: "none",
                              fontWeight: "bold",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                              "&:hover": { backgroundColor: "#f5f5f5" },
                              borderRadius: "9999px", // 🔘 redondeado tipo píldora
                              px: 3, // padding horizontal extra
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            Continuar
                          </Button>
                          {flujoFinal === "EXPRESS" && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                routeChange(true);
                              }}
                              sx={{
                                backgroundColor: "#FFFFFF",
                                color: "#000",
                                textTransform: "none",
                                fontWeight: "bold",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                                borderRadius: "9999px", // 🔘 redondeado tipo píldora
                                px: 3, // padding horizontal extra
                                "&:hover": { backgroundColor: "#f5f5f5" },
                              }}
                            >
                              Deseo Mayor Monto!
                            </Button>
                          )}
                        </Stack>
                      )}
                    </Box>

                    {/* Imagen del personaje rojo */}
                    <Box
                      component="img"
                      src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                      alt="Figura roja"
                      sx={{
                        width: 175,
                        height: "auto",
                        ml: 2,
                        mt: { xs: 2, sm: 0 },
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </DialogContent>
          </Dialog>

          <Button
            size="lg"
            variant="outlined"
            startIcon={<HouseIcon />}
            onClick={() => handleRedirect()}
          >
            <Typography> Regresar a la pagina Principal</Typography>
          </Button>
        </Div>
      )}
    </>
  );
};

export default ValidarCedula;
